import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    collapsedText: String,
    expandedText: String,
    targetSelector: String
  }

  connect() {
    this.handleShown = this.updateExpandedState.bind(this, true)
    this.handleHidden = this.updateExpandedState.bind(this, false)

    this.collapseTarget = document.querySelector(this.targetSelectorValue || this.element.getAttribute("data-target"))

    if (this.collapseTarget) {
      this.collapseTarget.addEventListener("shown.bs.collapse", this.handleShown)
      this.collapseTarget.addEventListener("hidden.bs.collapse", this.handleHidden)
      const isExpanded = this.collapseTarget.classList.contains("show") || this.element.getAttribute("aria-expanded") === "true"
      this.updateExpandedState(isExpanded)
    } else {
      this.updateExpandedState(false)
    }
  }

  disconnect() {
    if (this.collapseTarget) {
      this.collapseTarget.removeEventListener("shown.bs.collapse", this.handleShown)
      this.collapseTarget.removeEventListener("hidden.bs.collapse", this.handleHidden)
    }
  }

  togglePending(event) {
    const willExpand = this.element.getAttribute("aria-expanded") !== "true"
    this.updateExpandedState(willExpand)
  }

  updateExpandedState(isExpanded) {
    if (isExpanded) {
      this.element.textContent = this.expandedTextValue || this.element.textContent
      this.element.setAttribute("aria-expanded", "true")
    } else {
      this.element.textContent = this.collapsedTextValue || this.element.textContent
      this.element.setAttribute("aria-expanded", "false")
    }
  }
}
